import ModelService from "./abstract/ModelService"
import ContractExtension from "../models/ContractExtension"

export default class ContractExtensionService extends ModelService {
  constructor(contractId) {
    super('/contracts/' + contractId + '/extensions', ContractExtension)
  }
}
